import SEO from "components/seo"
import { Helmet } from "react-helmet"
import CheckoutLogin from "components/pages/checkout/checkout-login"
import Layout from "components/layout"

const CheckoutLoginPage = () => {

  return (
    <Layout onlyMain>
      <SEO title="Login Checkout" />
      <Helmet>
        <body className="bd-checkout-auth" />
      </Helmet>
      <CheckoutLogin />
    </Layout>
  )
}

export default CheckoutLoginPage
